import {
  UPDATE_SET_SUCCESS,
  UPDATE_SET_FAILED,
  CLEAR_UPDATE_SET,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SET_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case UPDATE_SET_FAILED:
      return { ...state, status: 'error', error: action.error };

    case CLEAR_UPDATE_SET:
      return initialState;
    default:
      return state;
  }
};
